var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45.923 41.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.148,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee6e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7866f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1160",
    "data-name": "Trac\\xE9 1160",
    d: "M24.962,16.777a4.592,4.592,0,1,1,4.592-4.592A4.592,4.592,0,0,1,24.962,16.777Zm7.536.659a6.909,6.909,0,0,1,3.587,4.034l4.377-3.5a4.592,4.592,0,0,1,7.461,3.586v18a4.592,4.592,0,0,1-7.461,3.586l-4.377-3.5a6.891,6.891,0,0,1-6.531,4.692H8.889A6.888,6.888,0,0,1,2,37.443V23.666a6.874,6.874,0,0,1,2.433-5.254,9.185,9.185,0,1,1,13.64-12.3A9.185,9.185,0,0,1,32.5,17.436ZM15.777,12.185a4.592,4.592,0,1,1-4.592-4.592A4.592,4.592,0,0,1,15.777,12.185ZM8.889,21.369H29.554a2.3,2.3,0,0,1,2.3,2.3V37.443a2.3,2.3,0,0,1-2.3,2.3H8.889a2.3,2.3,0,0,1-2.3-2.3V23.666A2.3,2.3,0,0,1,8.889,21.369Zm27.554,5.7v6.979l6.888,5.51v-18Z",
    transform: "translate(-2 -3)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraHeader);
export default __webpack_public_path__ + "static/media/CameraHeader.c407cc63e9af690fdf965b2a2a8a87fe.svg";
export { ForwardRef as ReactComponent };